<template>
  <div class="login-layout">
    <header class="header">
      <h1 class="company-name">{{ $store.state.title }}</h1>
    </header>

    <transition>
      <router-view></router-view>
    </transition>

    <v-footer></v-footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
    'v-footer': Footer
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/style/colors';

.login-layout {
  background-color: #f5f5f5;
}

.header {
  position: relative;
  height: 214px;
  background: url(../assets/new/loginbg.png) no-repeat top;
  padding-top: 1px;
}

.footer {
  margin-top: 70px;
}

.company-name {
  width: 720px;
  font-size: 26px;
  font-weight: 400;
  color: #fff;
  margin: 49px auto 0;
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/LoginLayout.vue